import React from 'react';

import { SimpleSailing, SimpleSailingDay } from '../../shared/types/sailing';
import { FormGroup, Header, Button } from '@spark-labs/avocado-ui';
import { getDayLocation, getDayFirstArrival, getDayLastDeparture } from '@go-shared/lib/sailing';
import { DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT } from '@go-shared/lib/time';

export interface SailingFormProps {
  sailing: SimpleSailing;
  onSubmit?: (sailing: SimpleSailing) => void;
}

export interface SailingFormState {
  selectedRow: number;
  editedSailing: SimpleSailing;
}

export default class SailingForm extends React.Component<SailingFormProps, SailingFormState> {
  public readonly state: SailingFormState;

  constructor(props: SailingFormProps) {
    super(props);

    this.handleDayTypeChange = this.handleDayTypeChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    // Clone the sailing days so we don't modify the sailing we get in props
    this.state = {
      selectedRow: -1,
      editedSailing: {
        ...props.sailing,
        days: props.sailing.days.map(day => Object.assign({}, day)),
      },
    };
  }

  public render() {
    return (
      <div className="border-t border-grey pt-2 p-4 mt-6" style={{ width: '700px' }}>
        <FormGroup className="w-full py-2 px-4">
          <Header size="sm">Hours</Header>
          <table className="border w-full text-left">
            <thead>
              <tr className="text-teal-dark">
                <th>Day</th>
                <th>Location</th>
                <th>Day Type</th>
                <th>Arrival</th>
                <th>Departure</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {this.state.editedSailing.days.map((day, i) => {
                // FIXME: We don't really support multi port days
                let rowSelected = this.state.selectedRow === i;
                let firstArrival = getDayFirstArrival(
                  day,
                  DEFAULT_HOUR_FORMAT,
                  DEFAULT_TIMESTR_FORMAT
                );
                let lastDeparture = getDayLastDeparture(
                  day,
                  DEFAULT_HOUR_FORMAT,
                  DEFAULT_TIMESTR_FORMAT
                );
                return (
                  <tr
                    key={day._id}
                    className="text-grey-dark"
                    onClick={() => this.handleRowClick(i)}
                  >
                    <td>{day.name}</td>
                    <td>{getDayLocation(day)}</td>
                    <td>
                      {rowSelected ? (
                        <select
                          onChange={e => this.handleDayTypeChange(day, e)}
                          className="bg-grey-lightest w-4/5"
                          value={day.type}
                        >
                          <option value="sea">sea</option>
                          <option value="port">port</option>
                        </select>
                      ) : (
                        day.type
                      )}
                    </td>
                    <td>{firstArrival !== '' ? firstArrival : '--'}</td>
                    <td>{lastDeparture !== '' ? lastDeparture : '--'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </FormGroup>
        <div className="mt-4 flex justify-end">
          <div className="mx-2">
            <Button color="green" onClick={this.handleFormSubmit}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  }

  private handleRowClick(rowIndex: number) {
    this.setState({ selectedRow: rowIndex });
  }

  private handleDayTypeChange(
    sailingDay: SimpleSailingDay,
    event: React.ChangeEvent<HTMLSelectElement>
  ) {
    sailingDay.type = event.target.value as any;
    if (sailingDay.type === 'sea') {
      sailingDay.locations = [];
    }
    this.setState({ editedSailing: this.state.editedSailing });
  }

  private handleFormSubmit() {
    if (!this.state.editedSailing) return;
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.editedSailing);
    }
  }
}
